<template>
  <div class="image-upload" @click="openFileBrowser">
    <input type="file" ref="fileInput" accept="image/*" :multiple="multiple" @input="handleImageUpload" />

    <slot></slot>
  </div>
</template>

<style lang="scss">
.image-upload {
  input[type="file"] {
    position: absolute;
    transform: scale(0);
  }
}
</style>

<script>
export default {
  name: "ImageUpload",
  props: {
    multiple: Boolean,
  },
  methods: {
    handleImageUpload: async function () {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']; // Tipi di immagine consentiti

      if (this.multiple) {
        const uploadedImages = this.$refs.fileInput.files;
        let loaded = 0;

        if (!uploadedImages) return;

        for (const image of uploadedImages) {
          // Filtro per formato (tipo MIME)
          if (!allowedTypes.includes(image.type)) {
            this.$bvToast.toast(`Il formato del file ${image.name} non è valido. Solo JPEG, PNG e GIF sono supportati.`, {
              title: "Errore formato",
              variant: "danger", // Colore del toast
              solid: true,
            });
            continue; // Non caricare l'immagine se il formato non è valido
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
              // Filtro per rapporto di aspetto (orizzontale)
              if (img.width <= img.height) {
                // Se l'immagine è verticale (larghezza <= altezza)
                this.$bvToast.toast(`L'immagine ${image.name} è verticale. Solo immagini orizzontali sono accettate.`, {
                  title: "Errore proporzioni",
                  variant: "danger", // Colore del toast
                  solid: true,
                });
                return; // Non caricare l'immagine se non è orizzontale
              }

              // Se l'immagine è orizzontale, carica l'immagine
              image.url = e.target.result;
              loaded++;

              if (loaded === uploadedImages.length) {
                this.$emit("uploaded-images", uploadedImages);
              }
            };
            img.src = e.target.result;
          };
          reader.readAsDataURL(image); // Leggi il file come DataURL
        }
      } else {
        const uploadedImage = this.$refs.fileInput.files[0];
        if (!uploadedImage) return;

        // Filtro per formato (tipo MIME)
        if (!allowedTypes.includes(uploadedImage.type)) {
          this.$bvToast.toast(`Il formato del file ${uploadedImage.name} non è valido. Solo JPEG, PNG e GIF sono supportati.`, {
            title: "Errore formato",
            variant: "danger", // Colore del toast
            solid: true,
          });
          return; // Non caricare l'immagine se il formato non è valido
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            // Filtro per rapporto di aspetto (orizzontale)
            if (img.width <= img.height) {
              // Se l'immagine è verticale (larghezza <= altezza)
              this.$bvToast.toast(`L'immagine ${uploadedImage.name} è verticale. Solo immagini orizzontali sono accettate.`, {
                title: "Errore proporzioni",
                variant: "danger", // Colore del toast
                solid: true,
              });
              return; // Non caricare l'immagine se non è orizzontale
            }

            // Se l'immagine è orizzontale, carica l'immagine
            uploadedImage.url = e.target.result;
            this.$emit("uploaded-image", uploadedImage);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(uploadedImage); // Leggi il file come DataURL
      }
    },


    openFileBrowser: function () {
      this.$refs.fileInput.click();
    },
    propagateDeletionOfFile(realFiles) {
      let list = new DataTransfer()
      realFiles.forEach((x) => list.items.add(x))
      this.$refs.fileInput.files = list.files
    }
  },
};
</script>